import { IBEError } from '@common/interfaces/be-error.interface';
import { ICollection } from '@common/interfaces/collection.interface';
import { UseQueryOptions } from '@common/interfaces/query-options.interface';
import { createCollection } from '@common/utils/create-collection.util';
import { TItemV1ItemGetError } from '@src/api/item-generated-api';
import {
    createCachedProductCatalogItemDto,
    ICachedProductCatalogItemDto,
} from '@src/api/model/cached-product-catalog-item.dto';
import { createProductCatalogItemDto, IProductCatalogItemDto } from '@src/api/model/product-catalog-item.dto';
import { EPackhouseV1ProductCatalogGet_Type, EPackhouseV2ProductCatalogGet_Type, packHouseApiRequest, TPackhouseV2ProductCatalogGetError } from '@src/api/pack-house-generated-api';
import { queryClient } from '@src/shared/query-client';
import { useQuery, UseQueryResult } from 'react-query';

const NAME = 'product-catalog-cache';

const useGetProducts = (
    queryOptions?: UseQueryOptions,
): UseQueryResult<ICollection<IProductCatalogItemDto>, IBEError<TPackhouseV2ProductCatalogGetError>> => {
    return useQuery<ICollection<IProductCatalogItemDto>, IBEError<TPackhouseV2ProductCatalogGetError>>(
        `product-catalog-all-list`,
        () => {
            return packHouseApiRequest
                .packhouseV2ProductCatalogGet({
                    limit: 1000, type:
                        EPackhouseV2ProductCatalogGet_Type.all
                }, {})
                .then((r) => createCollection(r.data.list?.map((e) => createProductCatalogItemDto(e)) || [], 0, {}));
        },
        queryOptions,
    );
};




const useGetCachedProducts = (
    queryOptions?: UseQueryOptions,
): UseQueryResult<ICollection<ICachedProductCatalogItemDto>, IBEError<TItemV1ItemGetError>> => {
    return useQuery<ICollection<ICachedProductCatalogItemDto>, IBEError<TItemV1ItemGetError>>(
        `${NAME}-all-list`,
        () => {
            return packHouseApiRequest
                .packhouseV1ProductCatalogGet({ limit: 1000, type: EPackhouseV1ProductCatalogGet_Type.all })
                .then((r) => createCollection(r.data.list?.map((e) => createCachedProductCatalogItemDto(e)) || [], 0, {}));
        },
        queryOptions,
    );
};

const getProductsFromCache = (): ICollection<IProductCatalogItemDto> | undefined => {
    return queryClient.getQueryData(`product-catalog-all-list`);
};

export const filterActivePlans = (
    products: IProductCatalogItemDto[] | undefined,
): ICollection<IProductCatalogItemDto> => {
    return createCollection(
        products?.filter(
            (product) => product.item?.type === 'plan' &&
                product.item?.status === 'active' &&
                product.item.prices.filter((price) => price.period !== 4).some((price) => !price.cf_hidden),
        ), 0, {},
    );
};

// Don't show monthly boxes and only with some active price
export const filterActiveProductsWithoutMonthlyPriceWithOneAtMiniumActivePrice = (
    products: ICachedProductCatalogItemDto[] | undefined,
): ICollection<ICachedProductCatalogItemDto> => {
    return createCollection(
        products?.filter(
            (product) =>
                product.item?.type === 'plan' &&
                product.item?.status === 'active' &&
                !product.item.cf_hidden &&
                product.item.prices.filter((price) => price.period !== 4).some((price) => !price.cf_hidden),
        ),
        0,
        {},
    );
};
export const products = {
    useGetCachedProducts,
    getProductsFromCache,
    useGetProducts
};
